import { Route, Routes } from "react-router-dom"
import {
  BOTTOM_BAR_HEIGHT,
  TOP_BAR_HEIGHT,
} from "../../miscellaneous/constants"
import Tabs from "../Tabs"
import TopBar from "../TopBar"
import FileList from "../FileList"
import { Props } from "./Authenticated.types"
import StatsGrid from "../StatsGrid"
import Notifications from "../Notifications"

const Authenticated = ({ mobile }: Props) => {
  return (
    <>
      <TopBar mobile={mobile} />
      <div
        style={{
          height: `calc(100% - ${
            TOP_BAR_HEIGHT + (mobile ? BOTTOM_BAR_HEIGHT : 0)
          }px)`,
          overflow: "auto",
        }}
      >
        <Routes>
          <Route path="/" element={<StatsGrid mobile={mobile} />} />
          <Route
            path="/info"
            element={<FileList mobile={mobile} section="info" />}
          />
          <Route
            path="/faqs"
            element={<FileList mobile={mobile} section="faq" />}
          />
          <Route
            path="/videos"
            element={<FileList mobile={mobile} section="video" />}
          />
          <Route path="/notifications" element={<Notifications />} />
        </Routes>
      </div>
      {mobile && (
        <div style={{ height: BOTTOM_BAR_HEIGHT + "px" }}>
          <Tabs mobile={mobile} />
        </div>
      )}
    </>
  )
}

export default Authenticated
